import type { FC } from 'react'
import { Checkbox as MuiCheckbox, type CheckboxProps as MuiCheckboxProps } from '@mui/material'

/**
 * The MUI Checkbox with `color` and `disableRipple` taken out.
 *
 * The theme already sets these, so passing them does nothing.
 * hiding them from the type just stops us doing it by accident.
 */
export type CheckboxProps = Omit<MuiCheckboxProps, 'color' | 'disableRipple'>

export const Checkbox: FC<CheckboxProps> = MuiCheckbox
